import { normalize } from 'normalizr'
import { Schemas } from '@redux/schema'
import { updateEntities } from '@redux/entities'

import api from '@functions/api'

import type { BillingTypeModel } from '@models/billingType'
import type { AppDispatch } from '@redux/store'
import type {
  Action, ActionResult, EntityOptions, Errors,
} from '@redux/modules/types'

import { handleError } from '../utils'

const FETCH_REQUEST = 'realbase/billingType/FETCH_REQUEST'
const FETCH_SUCCESS = 'realbase/billingType/FETCH_SUCCESS'
const FETCH_FAILURE = 'realbase/billingType/FETCH_FAILURE'

export type BillingTypeModuleState = {
  errors: string[],
  loaded: boolean,
  loading: boolean,
}

const initialState: BillingTypeModuleState = {
  errors: [],
  loaded: false,
  loading: false,
}

// Actions
export function fetchRequest(): Action {
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(): Action {
  return {
    type: FETCH_SUCCESS,
  }
}

export function fetchFailure(errors: Errors = []): Action {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

// Action Creators
export function loadBillingTypes(options: EntityOptions = {}) {
  return (dispatch: AppDispatch): Promise<ActionResult<BillingTypeModel[]>> => {
    dispatch(fetchRequest())

    const promise = api('/billing-types', options)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.BILLING_TYPE_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(fetchFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

// Reducer
export default function reducer(
  state: BillingTypeModuleState = initialState,
  action: Action = { type: '' },
): BillingTypeModuleState {
  switch (action.type){
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        errors: [],
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors: action.errors || [],
      }
    default:
      return state
  }
}
